export default __webpack_public_path__ + "static/CommunityBranding-7d3475c4c65f7b975422a70733da87f5.jpg";